import {Dispatch, SetStateAction, useState} from "react";
import {FiTrash} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {TableCrownButton} from "@/components/tableCrownButton/TableCrownButton.tsx";
import {MaintenanceScheduleListItem} from "@/lib/types/maintenance.ts";
import {BulkDeleteSchedulesDialog} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/actions/BulkDeleteSchedulesDialog.tsx";

interface TableBulkActionsBarProps {
  schedules: MaintenanceScheduleListItem[];
  selectedItems: Record<string, boolean>;
  setSelectedItems: Dispatch<SetStateAction<Record<string, boolean>>>;
}

export const TableBulkActionsBar = ({schedules, selectedItems, setSelectedItems}: TableBulkActionsBarProps) => {
  const [show, setShow] = useState(false);
  const selectedSchedules = schedules.filter((s) => selectedItems[String(s.id)]);
  const disabled = selectedSchedules.length === 0;

  return (
    <>
      <TableCrownButton disabled={disabled} onClick={() => setShow(true)}>
        <Icon icon={FiTrash} />
        Delete Schedule
      </TableCrownButton>
      <BulkDeleteSchedulesDialog
        schedules={selectedSchedules}
        show={show}
        onClose={() => setShow(false)}
        onSuccess={() => setSelectedItems({})}
      />
    </>
  );
};
